<template>
  <b-menu>
    <b-menu-list>
      <router-link
        to="/user/applications"
        class="menu-item"
        @click.native="onClick"
      >
        <b-icon
          class="is-inline-block mr-4 menu-icon"
          icon-pack="fa"
          icon="wallet"
          size="is-small"
        ></b-icon>
        <span>{{ $t("af:sidebar.applications") }}</span>
      </router-link>

      <router-link to="/user/todos" class="menu-item" @click.native="onClick">
        <b-icon
          class="is-inline-block mr-4 menu-icon"
          icon-pack="fa"
          icon="clipboard-list"
          size="is-small"
        ></b-icon>
        <span
          >{{ $t("af:sidebar.my_todos") }}
          <span class="todo-badge" v-if="todoCount > 0">
            {{ todoCount }}
          </span>
        </span>
      </router-link>

      <router-link
        to="/user/purchase-history"
        class="menu-item"
        @click.native="onClick"
      >
        <b-icon
          class="is-inline-block mr-4 menu-icon"
          icon-pack="fa"
          icon="book"
          size="is-small"
        ></b-icon>
        <span>{{ $t("af:sidebar.purchase_history") }}</span>
      </router-link>

      <router-link to="/user/profile" class="menu-item" @click.native="onClick">
        <b-icon
          class="is-inline-block mr-4 menu-icon"
          icon-pack="fa"
          icon="user-cog"
          size="is-small"
        ></b-icon>
        <span>{{ $t("af:sidebar.profile") }}</span>
      </router-link>

      <router-link to="/stores" class="menu-item" @click.native="onClick">
        <b-icon
          class="is-inline-block mr-4 menu-icon"
          icon-pack="fa"
          icon="store"
          size="is-small"
        ></b-icon>
        <span>{{ $t("af:sidebar.stores") }}</span>
      </router-link>

      <router-link :to="backPath" class="menu-item" @click.native="onClick">
        <b-icon
          class="is-inline-block mr-4 menu-icon"
          icon-pack="fa"
          icon="backspace"
          size="is-small"
        ></b-icon>
        <span>{{ $t("af:sidebar.back") }}</span>
      </router-link>
    </b-menu-list>
  </b-menu>
</template>

<script>
import eventBus, { EVENTS } from "@/utils/eventBus";
import Vue from "vue";
import { mapGetters } from "vuex";

export default {
  name: "MenuContent",
  created() {
    this.onStatusUpdated();
    eventBus.$on(EVENTS.STATUS_UPDATED, this.onStatusUpdated);
  },
  destroyed() {
    eventBus.$off(EVENTS.STATUS_UPDATED);
  },
  data() {
    return {
      backPath: "",
    };
  },
  computed: {
    ...mapGetters({
      todoCount: "myTodo/getCount",
    }),
  },
  methods: {
    onStatusUpdated() {
      Vue.set(this, "backPath", this.$store.getters["profile/getBackPath"]);
    },
    onClick() {
      this.$emit("click");
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/colors.scss";

.todo-badge {
  margin-left: 2rem;
  background-color: $red;
  padding: 0.2rem 0.7rem;
  border-radius: 6px;
  color: white;
  font-size: 14px;
}
</style>
